import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiAlertModule, TuiNotificationModule } from '@taiga-ui/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-forbidden-page',
  standalone: true,
  imports: [TuiAlertModule, TuiNotificationModule, TranslocoPipe],
  templateUrl: './forbidden-page.component.html',
  styleUrl: './forbidden-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForbiddenPageComponent {}
